'use client';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { ButtonBase, Container, Tab, Tabs } from '@mui/material';
import Link from 'next/link';
import { FC } from 'react';

import { AbgTypography, mergeSx } from '@abg/kit-base';

import { useAnalyticsUpdatePageReference } from '../../shared/analytics/hooks';

import * as styles from './horizontal-subnav.styling';
import { HorizontalSubnavProperties } from './horizontal-subnav.types';

export const HorizontalSubnav: FC<HorizontalSubnavProperties> = ({
  model,
  aemAttributes,
  styleParts,
}) => {
  const { items } = model;
  const activeItem = items?.find((item) => item.active);
  const { updateAnalyticsPageReference } = useAnalyticsUpdatePageReference();

  return (
    <Container
      sx={styleParts?.root || {}}
      maxWidth="xl"
      {...aemAttributes}
      data-aue-type="component"
    >
      <Tabs
        value={activeItem?.title}
        sx={styles.navTabsWrapper}
        slots={{
          indicator: () => null,
          endScrollButtonIcon: () => (
            <ButtonBase
              disableRipple
              aria-label="Scroll to end"
              sx={{
                p: 0,
                '&.Mui-focusVisible': {
                  border: '2px solid black',
                  background: 'none',
                },
              }}
            >
              <KeyboardArrowRightIcon fontSize="small" />
            </ButtonBase>
          ),
          startScrollButtonIcon: () => (
            <ButtonBase
              disableRipple
              aria-label="Scroll to start"
              sx={{
                p: 0,
                '&.Mui-focusVisible': {
                  border: '2px solid black',
                  background: 'none',
                },
              }}
            >
              <KeyboardArrowLeftIcon fontSize="small" />
            </ButtonBase>
          ),
        }}
        variant="scrollable"
        scrollButtons
        allowScrollButtonsMobile
        data-testid="nav-bar-list"
      >
        {items?.map(({ title, url }) => {
          return (
            <Tab
              sx={styles.horizontalSubnavTab}
              key={title}
              value={title}
              href={url}
              component={Link}
              prefetch={false}
              onClick={() => {
                const isProfile =
                  aemAttributes['data-aue-resource']?.includes(
                    'dashboard/profile',
                  );
                if (isProfile) {
                  updateAnalyticsPageReference();
                }
              }}
              label={
                <AbgTypography
                  variant="h5"
                  sx={mergeSx(
                    styles.HorizontalSubnavText,
                    styleParts?.HorizontalSubnavText,
                  )}
                >
                  {title}
                </AbgTypography>
              }
            />
          );
        })}
      </Tabs>
    </Container>
  );
};
